
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import axios from 'axios'
import RoomList from '@/components/RoomList.vue'
import HeatingTypes from '@/components/HeatingTypes.vue'
import TermostatFilterCriteria from '@/components/TermostatFilterCriteria.vue'
import TermostatProductSelection from '@/components/TermostatProductSelection.vue'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    RoomList,
    HeatingTypes,
    TermostatFilterCriteria,
    TermostatProductSelection,
    HelperTooltip
  },

  data: () => ({
    fetching: false,
    tableEmptyError: '',
    selectedProductsError: ''
  }),

  computed: {
    ...mapFields({
      selectedTermostatProducts: 'selectedTermostatProducts',
      roomsData: 'roomsData',
      projectTitle: 'projectData.projectTitle',
      rules: 'projectData.rules',
      projectForm: 'formValidity.projectForm',
      roomsForm: 'formValidity.roomsForm'
    })
  },

  methods: {
    generate () {
      const quoteData = this.$store.getters.getAllDataAsJson

      const projectFormValid = (this as any).$refs.projectFormRef.validate()//eslint-disable-line
      const roomTableValid = this.validateRoomsData()
      if (!projectFormValid || !roomTableValid) { //eslint-disable-line
        ((this as any).$refs.projectFormRef.$el as HTMLElement).scrollIntoView()  // eslint-disable-line
        return
      }

      this.fetching = true

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?generate', quoteData)
        .then(response => {
          this.$emit('moveToNext')
          this.$store.commit('setQuote', response.data)
        })
        .catch(error => console.log(error))
        .finally(() => { this.fetching = false })
    },

    validateRoomsData (): boolean {
      this.tableEmptyError = ''

      const bTableEmpty = (this as any).roomsData.length === 0 //eslint-disable-line

      if (bTableEmpty) {
        this.tableEmptyError = 'Legalább egy helyiség megadása kötelező!'
      }

      return !bTableEmpty
    },

    validateSelectedProducts (): boolean {
      this.selectedProductsError = ''

      const bNoSelectedProduct = this.selectedTermostatProducts.pro2.length === 0 && this.selectedTermostatProducts.tech.length === 0 && this.selectedTermostatProducts.heatmiser.length === 0

      if (bNoSelectedProduct) {
        this.selectedProductsError = 'Legalább egy termék kiválasztása kötelező!'
      }

      return !bNoSelectedProduct
    },

    handleTermostatFilterCriteriaSubmit () {
      this.selectedProductsError = ''
    }
  },

  watch: {
    roomsData (newVal) {
      if (newVal.length > 0) {
        this.tableEmptyError = ''
      }
    }
  }
})
